import {
  faArrowRight,
  faCode,
  faGlobe,
  faLaptopCode,
  faMobileAlt,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import servicesHero from "../Assets/heroes/services-hero.webp";
import CallToAction from "../Components/CallToAction";
import PrimaryHero from "../Components/PrimaryHero";
import SectionHeading from "../Components/SectionHeading";

const services = [
  {
    icon: faScrewdriverWrench,
    label: "Custom tools",
    title: "Business software",
    copy: "Simple systems for records, reports, approvals, and daily work that should be easier to manage.",
  },
  {
    icon: faGlobe,
    label: "Web access",
    title: "Web apps",
    copy: "Responsive websites and web apps that help people find information, complete tasks, and use services clearly.",
  },
  {
    icon: faMobileAlt,
    label: "Mobile use",
    title: "Mobile apps",
    copy: "Android and cross-platform apps that put the right features in people's hands when they need them.",
  },
  {
    icon: faLaptopCode,
    label: "Product support",
    title: "Product improvement",
    copy: "Updates, redesigns, and focused fixes that make existing software clearer, faster, and easier to maintain.",
  },
];

function Services() {
  return (
    <div className="primary-page">
      <PrimaryHero
        titleId="services-title"
        icon={faCode}
        kicker="Services"
        title="Software services that make work simpler."
        description={
          <p>
              MileSoft plans, builds, and improves practical web, mobile, and
              business software for real tasks.
          </p>
        }
        imageSrc={servicesHero}
        actions={
          <>
              <Link to="/contacts" className="btn-ms btn-ms-primary btn-ms-lg">
                Start a project
                <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
              </Link>
              <Link
                to="/portfolio"
                className="btn-ms btn-ms-secondary btn-ms-lg"
              >
                View work
              </Link>
          </>
        }
      />

      <section
        className="section-ms section-ms-soft"
        aria-labelledby="service-list-title"
      >
        <div className="section-ms-inner">
          <SectionHeading
            titleId="service-list-title"
            kicker="What we build"
            title="Choose the help you need"
            description={
              <p>
              Each service starts with the outcome you need, then stays focused
              on the features that help people move forward.
              </p>
            }
          />
          <div className="primary-card-grid primary-card-grid-four">
            {services.map((service) => (
              <article
                className="card-ms primary-info-card"
                key={service.title}
              >
                <div className="card-ms-body">
                  <div className="primary-card-meta">
                    <span className="brand-icon" aria-hidden="true">
                      <FontAwesomeIcon icon={service.icon} />
                    </span>
                    <span className="badge-ms" aria-label={service.label}>
                      {service.label}
                    </span>
                  </div>
                  <h3>{service.title}</h3>
                  <p>{service.copy}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CallToAction
        titleId="service-next-title"
        kicker="Next step"
        title="Tell us what needs to work better."
        description={
          <p>
              Share the task, workflow, or product idea. We will help shape a
              simple plan for the right digital solution.
          </p>
        }
        action={
          <Link to="/contacts" className="btn-ms btn-ms-primary btn-ms-md">
            Contact MileSoft
          </Link>
        }
      />
    </div>
  );
}

export default Services;
